import React from 'react'

const Unauthorized: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="text-9xl mb-4">😢</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-lg text-gray-600 mb-4">
            You are not authorized to access this application.
          </p>
          <p className="text-sm text-gray-500">
            This application is restricted to authorized Google Workspace accounts only.
          </p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-sm font-semibold text-gray-900 mb-2">Need Access?</h2>
          <p className="text-sm text-gray-600">
            If you believe you should have access to this application, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Unauthorized
